<template>
    <div class="slider-item-content"
        :data-position="position"
        :data-snap="snap"
        :data-url="item.url"
        :style="{ borderWidth: `${borderWidth}px;`, background: (type == 'VerticalProducts') ? `url('${item.image}') center center / cover` : null }"
        @click="fnGotoUrl && fnGotoUrl(item.url)" 
        v-observe-visibility="{
            callback: visibilityChanged,
            intersection:{
                rootMargin: `${width}px 0px ${height}px 0px`
            }
        }"
        ref="blockItem">
        <Mub :blockProduct="item">
            <a v-if="inViewPort && alreadyAppear" :href="item.url" class="w-100 h-100 slider-item-href" :aria-label="item.name">&nbsp;</a>
            <Video v-if="video" :video="video" class="h-100 slider-item-video" :pause="!inViewPort"></Video>
            <template v-if="inViewPort && alreadyAppear">
                <BlockImage v-if="type!='VerticalProducts'" 
                    :classNames="'w-100 h-100 slider-item-img'" 
                    :classNamesBox="'w-100 h-100'"
                    :isScrolled="alreadyAppear" 
                    :image="item.image" 
                    :width="width" 
                    :height="height" 
                    :title="item.name">
                </BlockImage>
                <div class="shadow-bottom">
                    <div class="row m-0 w-100">
                        <div class="col p-0">
                            <a :href="item.url">
                                <span class="name-label pr-2" v-html="item.name"></span>
                            </a>
                            <span v-if="item.subtitle" class="name-label extra" v-html="item.subtitle" />
                        </div>
                        <div class="col-auto p-0">
                            <p class="price-strikethrough">{{ item.priceCrossed }}</p>
                            <p class="price-label">{{ item.price }}</p>
                        </div>
                    </div>
                </div>
                <BlockLabel v-if="item.label" :label="item.label" :timeCounter="item.timeCounter" />
                <BlockLikes v-if="item.likes" :likes="item.likes" :rank="item.ranking" :label-rank="item.rankingLabel"
                    :ranking-css-class="item.rankingCssClass" :isDesktop="isDesktop">
                </BlockLikes>
                <div v-if="(numeration && item.numeration)" class="slider-numeration">
                    {{ item.numeration }}
                </div>
            </template>
        </Mub>
    </div>
</template>

<script>
import BlockImage from '../../Common/Partials/BlockImage';
import BlockLikes from '../../Common/Partials/BlockLikes';
import BlockLabel from './BlockLabel';
import Common from '../../Common/Partials/BlockItem';
import Video from '@/components/Muffin/Video/Component';
import Mub from '@/components/Mub';

export default {
    extends: Common,
    components: {
        BlockImage,
        BlockLabel,
        BlockLikes,
        Video,
        Mub
    }
}
</script>